import BaseComponent from 'components/pages/FuelComsumption/NewVehicle';
import { postVehicle } from 'domains/api/fuel_comsumption/vehicles';
import { resetCurrentUser } from 'domains/current_user';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Vehicle } from 'types';

const NewVehicle: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (vehicle: Vehicle) => {
    setIsLoading(true);
    void postVehicle(vehicle)
      .then((_) => {
        navigate('/fuel_consumption/vehicles');
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  };

  return <BaseComponent isLoading={isLoading} onSubmit={onSubmit} />;
};

export default NewVehicle;
